/**
 * HOK
 *
 * This class holds all the necessary js function for the HOK module.
 */

class HOK {
    initSettings(screen) {
        const elm = jQuery(screen);
    }
}

const hok = new HOK();

function delete_hok_request(id) {
    custom_delete_with_confirmation(`/hok/deleteRequest/${id}`,id,"Weet u zeker dat u dit request wilt verwijderen?",'hokrequest', () => {
        squde_reload_for_flashes();
    });
    return false;
}

function run_hok_request(sender, id = '') {
    const loadingElement = id ? jQuery(sender) : jQuery('body');
    loadingElement.isLoading();
    let path = '/hok/run';
    if (id) {
        path += `/${id}`;
    }
    jQuery.post(path).done(() => {
        loadingElement.doneLoading();
        squde_reload_for_flashes();
        reload_location_if_needed(false);
    });
    return false;
}
